(() => {
  const selector = 'img.oke-media-image, img[class*="kl-private-reset-css"]';
  const popupImages = new Set([
    '/company/QBBMLb/images/3eb30b0e-39c8-4815-91a2-89c4729c7062.png',
    '/company/KrCnK3/images/36178863-c4bb-4b84-915f-f048db8edd67.png',
    '/company/JVDP38/images/3ac5c27c-efd3-43eb-9351-2e9517035c3c.png',
    '/company/Jkw2KC/images/af4a710c-96a3-43db-bf1d-0c3e86ef0628.png',
  ]);
  const managed = new WeakMap();
  const dimension = value => /^\d+$/.test(value || '') && Number(value) > 0 ? Number(value) : 0;

  function update(image) {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    const source = image.getAttribute('src') || '';
    const sourceSet = image.getAttribute('srcset') || '';
    const key = `${source}|${sourceSet}`;
    let state = managed.get(image);
    if (state && state.key !== key) {
      for (const attribute of ['width', 'height']) {
        if (state[attribute] && image.getAttribute(attribute) === state[attribute]) {
          image.removeAttribute(attribute);
        }
      }
      managed.delete(image);
      state = null;
    }
    const width = dimension(image.getAttribute('width'));
    const height = dimension(image.getAttribute('height'));
    if (width && height) return;
    if (!source && !sourceSet) return;

    let naturalWidth = 0;
    let naturalHeight = 0;
    if (image.complete && image.naturalWidth && image.naturalHeight) {
      naturalWidth = image.naturalWidth;
      naturalHeight = image.naturalHeight;
    } else if (source && !sourceSet) {
      try {
        const url = new URL(source, document.baseURI);
        if (url.hostname === 'd3k81ch9hvuctc.cloudfront.net' && !url.search && popupImages.has(url.pathname)) {
          naturalWidth = 1651;
          naturalHeight = 1884;
        }
      } catch {
        return;
      }
    }
    if (!naturalWidth || !naturalHeight) return;

    state = state || { key };
    if (!width) {
      state.width = String(height ? Math.max(1, Math.round(height * naturalWidth / naturalHeight)) : naturalWidth);
      image.setAttribute('width', state.width);
    }
    if (!height) {
      state.height = String(width ? Math.max(1, Math.round(width * naturalHeight / naturalWidth)) : naturalHeight);
      image.setAttribute('height', state.height);
    }
    managed.set(image, state);
  }

  function scan(node) {
    if (!(node instanceof Element)) return;
    update(node);
    node.querySelectorAll(selector).forEach(update);
  }

  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'width', 'height', 'class'],
  });
  document.addEventListener('load', event => update(event.target), true);
  scan(document.documentElement);
})();
